import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TIMEZONE_LIST } from "utils/constants";
import Dropdown from "components/Dropdown";
import Button, { SIZE } from "components/Button";
import { AccessTime, Loading } from "components/assets/Icons";
import FormField from "components/FormField";
import { STYLE } from "components/FormField/FormField";
import ImageField from "pages/Profile/components/ImageField";
import {
  changeTimezone,
  profileInfo,
  profilePhoto,
  profileTimezone,
} from "actions/profile";

import styles from "./Form.module.scss";

const Form = ({ isLoggedIn }) => {
  const dispatch = useDispatch();
  const [currentTimezone, setCurrentTimezone] = useState("");
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({
    title: "",
    value: "",
  });

  const profileData = useSelector((state) => state.profile);

  useEffect(() => {
    dispatch(profileTimezone);
    dispatch(profileInfo);
    dispatch(profilePhoto);
  }, [dispatch]);

  useEffect(() => {
    const current = TIMEZONE_LIST.find(
      (item) => item.value === profileData?.timezone
    );
    setCurrentTimezone(current);
  }, [profileData]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    setParams(params);

    // Submit the timezone actually shown in the dropdown. `params.value` is only
    // populated when the user reopens and re-selects; otherwise fall back to the
    // currently displayed timezone so Save does not wipe the stored value.
    const selectedTimezone = params?.value || currentTimezone?.value || "";

    isLoggedIn &&
      dispatch(changeTimezone(selectedTimezone)).then(() => setLoading(false));
  };

  return (
    <form
      className={styles.form}
      method="GET"
      action="submit"
      onSubmit={handleOnSubmit}
    >
      <ImageField label="Profile Image" photoUrl={profileData?.photo} />
      <FormField
        labelText="First Name"
        value={profileData?.info?.first_name || ""}
        style={STYLE.THIN}
        size={SIZE.SMALL}
        maxWidth="18.75rem"
        disabled
        className={styles.input}
      />
      <FormField
        labelText="Last Name"
        value={profileData?.info?.last_name || ""}
        style={STYLE.THIN}
        size={SIZE.SMALL}
        maxWidth="18.75rem"
        disabled
      />
      <FormField
        labelText="Email"
        value={profileData?.info?.email || ""}
        style={STYLE.THIN}
        size={SIZE.SMALL}
        maxWidth="18.75rem"
        disabled
      />
      <FormField
        labelText="Company Name"
        value={profileData?.info?.company_name || ""}
        style={STYLE.THIN}
        size={SIZE.SMALL}
        maxWidth="18.75rem"
        disabled
        className={styles.input}
      />
      <FormField
        labelText="My Team"
        value={profileData?.info?.team || ""}
        style={STYLE.THIN}
        size={SIZE.SMALL}
        maxWidth="18.75rem"
        disabled
      />

      <Dropdown
        defaultValue={currentTimezone}
        list={TIMEZONE_LIST}
        label="Timezone"
        className={styles.dropdown}
        icon={<AccessTime />}
        value={params}
        setValue={setParams}
      />
      <Button
        type="submit"
        size={SIZE.MIDDLE}
        className={styles.button}
        disabled={loading}
      >
        {loading ? <Loading /> : "Save"}
      </Button>
    </form>
  );
};

export default Form;
